import { IS_USE_PLEX_API } from '@namespace/games';
import { useLoadVirtualSportsDataOld } from './useLoadVirtualSportsDataOld';
import { useLoadVirtualSportsDataPlex } from './useLoadVirtualSportsDataPlex';

export const useLoadVirtualSportsData = IS_USE_PLEX_API
  ? useLoadVirtualSportsDataPlex
  : useLoadVirtualSportsDataOld;
